// extracted by mini-css-extract-plugin
export default {"mclCell":"mclCell---KUUw3 mclCell---GuVYK mclCellStyle---JF2SB"};